module.exports = __webpack_public_path__ + "static/fonts/notokr-light.251f03d.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/views/nutrilite/a7070-glister/font/notokr-light.woff2
// module id = rE4I
// module chunks = 0